// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-message .header-wrapper {
  padding: 10px 0 10px 0;
  background-color: rgba(247, 247, 248, 0.4);
  border-radius: 3px;
}
.info-message .brd {
  border-bottom: 1px solid #EBE9EB;
}
.info-message .content {
  margin: 10px 20px;
}
.info-message .offset {
  margin: 20px 10px;
}
@media (min-width: 768px) {
  .info-message .offset {
    margin: 20px;
  }
}
.info-message .info-title {
  font-weight: bold;
  font-size: 13px;
  color: #3e0d42;
}
.info-message .p {
  font-size: 12px;
  color: #6b556c;
}
.info-message .info-email {
  font-weight: bold;
  font-size: 12px;
  color: #29bb73;
}
.info-message .info-date {
  font-weight: bold;
  font-size: 12px;
  color: #6b556c;
}
.info-message .icon-pin {
  cursor: pointer;
  float: right;
}

.title-teams {
  display: flex;
  flex-direction: column;
}
@media (min-width: 1024px) {
  .title-teams {
    flex-direction: row;
    align-content: center;
  }
}
.title-teams > div {
  display: flex;
  align-items: center;
}
@media (min-width: 1024px) {
  .title-teams > div {
    flex-basis: 48%;
  }
}
@media (min-width: 1024px) {
  .title-teams .title-teams__home {
    flex-direction: row-reverse;
  }
  .title-teams .title-teams__home .title-name {
    margin: 0 12px 0 0;
  }
}
.title-teams .title-name {
  line-height: 1.1;
  font-weight: bold;
  color: #37003C;
  font-size: 14px;
}
@media (min-width: 568px) {
  .title-teams .title-name {
    margin: 0 0 0 12px;
  }
}
.title-teams .title-vs {
  align-self: flex-end;
  display: flex;
  text-align: center;
  justify-content: center;
  font-family: "Premier League";
  margin: 3px 0px;
  font-size: 14px;
  width: 30px;
  border-radius: 3px;
}
@media (min-width: 1024px) {
  .title-teams .title-vs {
    margin: 10px 1%;
    font-size: 16px;
  }
}
.title-teams .title-icon {
  height: 30px;
}
.title-time {
  text-align: right;
}
@media (min-width: 1024px) {
  .title-time {
    text-align: center;
  }
}

.title-icon {
  height: 30px;
  text-align: center;
  display: block;
  width: auto;
  margin-right: 0.5rem;
}
@media (min-width: 1024px) {
  .title-icon {
    margin: 0;
  }
}

.player-wrapper {
  border-bottom: 1px solid rgba(68, 68, 68, 0.1);
}

.player-name {
  color: #3E0D42;
  font-size: 14px;
  font-weight: bold;
}

.rejected {
  text-decoration: line-through;
}

.manager-name {
  color: #382738;
  font-size: 11px;
  margin-left: 10px;
}

.fx-item-same {
  flex-basis: 30%;
}

@media (max-width: 991px) {
  .info-block-col {
    width: 50%;
  }
}
@media (max-width: 768px) {
  .info-message .content {
    margin: 0;
    padding: 10px;
  }
  .info-message .btn-wrap {
    display: block;
    text-align: center !important;
    margin: 15px 0 0 0;
  }
  .info-message .btn-wrap button {
    margin: 0 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/dashboard/messages/message-info/message-info.component.scss","webpack://./src/styles/global/mixins/match.scss","webpack://./src/styles/global/_variables.scss"],"names":[],"mappings":"AAKE;EACE,sBAAA;EACA,0CAAA;EAEA,kBAAA;AALJ;AAQE;EACE,gCAAA;AANJ;AASE;EACE,iBAAA;AAPJ;AAUE;EACE,iBAAA;AARJ;AAUI;EAHF;IAII,YAAA;EAPJ;AACF;AAUE;EACE,iBAAA;EACA,eAAA;EACA,cAAA;AARJ;AAWE;EACE,eAAA;EACA,cAAA;AATJ;AAYE;EACE,iBAAA;EACA,eAAA;EACA,cAAA;AAVJ;AAaE;EACE,iBAAA;EACA,eAAA;EACA,cAAA;AAXJ;AAcE;EACE,eAAA;EACA,YAAA;AAZJ;;ACvCE;EACE,aAAA;EACA,sBAAA;AD0CJ;ACxCI;EAJF;IAKI,mBAAA;IACA,qBAAA;ED2CJ;AACF;ACvCI;EACE,aAAA;EACA,mBAAA;ADyCN;ACvCM;EAJF;IAKI,eAAA;ED0CN;AACF;ACtCM;EADF;IAEI,2BAAA;EDyCN;ECvCM;IACE,kBAAA;EDyCR;AACF;ACrCI;EACE,gBAAA;EACA,iBAAA;EACA,cCwBa;EDjBX,eAAA;ADiCR;AC9BM;EAbF;IAcI,kBAAA;EDiCN;AACF;ACvBI;EACE,oBAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,6BAAA;EACA,eAAA;EACA,eAAA;EAIA,WAAA;EACA,kBAAA;ADsBN;ACpBM;EAdF;IAeI,eAAA;IACA,eAAA;EDuBN;AACF;ACnBI;EACE,YAAA;ADqBN;ACbE;EACE,iBAAA;ADeJ;ACZI;EAJF;IAKI,kBAAA;EDeJ;AACF;;ACZE;EACE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,oBAAA;ADeJ;ACZI;EARF;IASI,SAAA;EDeJ;AACF;;AA7DA;EACI,8CAAA;AAgEJ;;AA7DA;EACI,cAAA;EACA,eAAA;EACA,iBAAA;AAgEJ;;AA9DA;EACI,6BAAA;AAiEJ;;AA/DA;EACI,cAAA;EACA,eAAA;EACA,iBAAA;AAkEJ;;AAhEA;EACI,eAAA;AAmEJ;;AA/DA;EACE;IACE,UAAA;EAkEF;AACF;AA/DA;EAEE;IACE,SAAA;IACA,aAAA;EAgEF;EA9DA;IACE,cAAA;IACA,6BAAA;IACA,kBAAA;EAgEF;EA/DE;IACE,oBAAA;EAiEJ;AACF","sourcesContent":["@import '../../../../../styles/global/variables';\n@import '../../../../../styles/global/mixins/match';\n\n.info-message {\n  \n  .header-wrapper {\n    padding: 10px 0 10px 0;\n    background-color: rgba(247, 247, 248, 0.4);\n    // border-bottom: 1px solid #EBE9EB;\n    border-radius: 3px;\n  }\n\n  .brd {\n    border-bottom: 1px solid #EBE9EB;\n  }\n\n  .content {\n    margin: 10px 20px;\n  }\n\n  .offset {\n    margin: 20px 10px;\n\n    @media (min-width: 768px) {\n      margin: 20px;\n    }\n  }\n\n  .info-title {\n    font-weight: bold;\n    font-size: 13px;\n    color: #3e0d42;\n  }\n\n  .p {\n    font-size: 12px;\n    color: #6b556c;\n  }\n\n  .info-email {\n    font-weight: bold;\n    font-size: 12px;\n    color: #29bb73;\n  }\n\n  .info-date {\n    font-weight: bold;\n    font-size: 12px;\n    color: #6b556c;\n  }\n\n  .icon-pin {\n    cursor: pointer;\n    float: right;\n  }\n}\n@include match-header();\n\n\n\n.player-wrapper {\n    border-bottom: 1px solid rgba(68,68,68,0.1);\n}\n\n.player-name {\n    color: #3E0D42;\n    font-size: 14px;\n    font-weight: bold;\n}\n.rejected {\n    text-decoration: line-through;\n}\n.manager-name {\n    color: #382738;\n    font-size: 11px;\n    margin-left: 10px;\n}\n.fx-item-same {\n    flex-basis: 30%;\n}\n\n\n@media (max-width: 991px) {\n  .info-block-col {\n    width: 50%;\n  }\n}\n\n@media (max-width: 768px) {\n \n  .info-message .content {\n    margin: 0;\n    padding: 10px;\n  }\n  .info-message .btn-wrap {\n    display: block;\n    text-align: center !important;\n    margin: 15px 0 0 0;\n    button {\n      margin: 0 !important;\n    }\n  }\n}\n","// MATCH\n@mixin match-header($size: small) {\n  .title-teams {\n    display: flex;\n    flex-direction: column;\n\n    @media (min-width: 1024px) {\n      flex-direction: row;\n      align-content: center;\n      //justify-content: space-between;\n      //padding: 10px 0 0;\n    }\n\n    > div {\n      display: flex;\n      align-items: center;\n\n      @media (min-width: 1024px) {\n        flex-basis: 48%;\n      }\n    }\n    // HOME TEAMS TABLET\n    .title-teams__home {\n      @media (min-width: 1024px) {\n        flex-direction: row-reverse;\n\n        .title-name {\n          margin: 0 12px 0 0;\n        }\n      }\n    }\n\n    .title-name {\n      line-height: 1.1;\n      font-weight: bold;\n      color: $card-title-color;\n\n      @if $size == 'big' {\n        font-size: 18px;\n      }\n\n      @if $size == 'small' {\n        font-size: 14px;\n      }\n\n      @media (min-width: 568px) {\n        margin: 0 0 0 12px;\n\n        @if $size == 'big' {\n          font-size: 24px;\n        }\n        @else {\n          //font-size: 16px;\n        }\n      }\n    }\n\n    .title-vs {\n      align-self: flex-end;\n      display: flex;\n      text-align: center;\n      justify-content: center;\n      font-family: \"Premier League\";\n      margin: 3px 0px;\n      font-size: 14px;\n      //font-weight: bold;\n      //background: #5d0666;\n      //color: white;\n      width: 30px;\n      border-radius: 3px;\n\n      @media (min-width: 1024px) {\n        margin: 10px 1%;\n        font-size: 16px;\n        //color: $title-gray-color;\n      }\n    }\n\n    .title-icon {\n      height: 30px;\n\n      @media (min-width: 576px) {\n        //height: 40px;\n      }\n    }\n  }\n\n  .title-time {\n    text-align: right;\n    //font-size: 12px;\n    //font-weight: bold;\n    @media (min-width: 1024px) {\n      text-align: center;\n    }\n  }\n  // DETAIL\n  .title-icon {\n    height: 30px;\n    text-align: center;\n    display: block;\n    width: auto;\n    margin-right: .5rem;\n\n\n    @media (min-width: 1024px) {\n      margin: 0;\n    }\n  }\n}\n\n","$grid-columns: 12 !default;\n$grid-gutter-width: 0 !default;\n\n// fonts\n$font-icon-path:'../assets/icons';\n$font-path: '../assets/fonts';\n$font-family-sans-serif: 'Premier League' !default;\n$font-weight-light: 300 !default;\n$font-weight-normal: 400 !default;\n$font-weight-bold: 600 !default;\n$btn-font-weight: $font-weight-bold;\n$btn-font-weight-sm: $font-weight-bold;\n$bold: bold;\n\n// sizes\n$card-title-font-size: 18px;\n$card-title-md-font-size: 16px;\n$card-title-large-font-size: 24px;\n$small-title-font-size: 13px;\n$small-label-font-size: 12px;\n$md-label-font-size: 13px;\n$lg-label-font-size: 13px;\n$font-size-base: 1.1rem !default; // Assumes the browser default, typically `16px`\n$font-size-lg: ($font-size-base * 1.25) !default;\n$font-size-sm: ($font-size-base * .875) !default;\n$input-btn-padding-x: 1.875rem !default;\n$input-btn-padding-y-sm: 0.5rem !default;\n$input-btn-padding-y: 0.8125rem !default;\n$input-btn-line-height: 0.8125 !default;\n$btn-border-radius: 0.1875rem !default;\n$thumbnail-border-radius: 0px;\n$input-btn-border-width: 1px !default;\n$card-inner-border-radius: 0px;\n$input-btn-border-width: 1px !default;\n\n// colors\n$pl-background-color: #F1F0F1 !default;\n$text-color-light: #963CFE;\n$purple: #11233f;\n$dark: #605260;\n$icons-normal-color: #6A556B;\n$light-gray:#F2F3F3;\n$sidebar-hover-color: #490050;\n$header-title-color: #490050;\n$primary: #FF2882;\n$menu-primary: #00FF87;\n\n// Radio & checkbox\n$custom-control-indicator-checked-color:        $primary;\n$custom-control-indicator-checked-bg:           white;\n// $custom-control-indicator-checked-disabled-bg:  rgba(theme-color(\"primary\"), .5) !default;\n$custom-control-indicator-checked-box-shadow:   none !default;\n$custom-control-indicator-checked-border-color: $primary;\n$custom-control-indicator-size: 1rem;\n$custom-control-indicator-bg-size: 0.85rem;\n\n$icons-hover-color: #963CFE;\n$link-hover-color: #963CFE;\n$icons-red-hover-color: #05F0FF;\n$card-title-color: #37003C;\n$panel-title-color: #3E0D42;\n$bold-text-color:#3e0d42;\n$color-default:#212529;\n$title-gray-color:#6b556c;\n$week-title-color: #5e0066;\n$action-icon-color: #8D4C93;\n$blue: #05F0FF !default;\n$red: #FF005A !default;\n$yellow: #ECE609 !default;\n$green: #00FF87 !default;\n$white: #FFFFFF !default;\n$secondary: #F1F0F1;\n$grayscale-90: #eee;\n$default-bg: $white !default;\n$input-btn-focus-color: $light-gray !default;\n$input-btn-disabled-color: $light-gray !default;\n$input-btn-disabled-text: #AFA9AF !default;\n$input-btn-disabled-border-color: #D7D4D7 !default;\n$input-btn-secondary-color: #FFFFFF !default;\n$input-btn-secondary-text: #382738 !default;\n$input-btn-secondary-border-color: #EBE9EB !default;\n$input-btn-secondary-hover-border-color: #AFA9AF !default;\n$input-btn-secondary-disabled-color: #FFFFFF !default;\n$input-btn-secondary-disabled-text: #AFA9AF !default;\n$input-btn-secondary-disabled-border-color: #EBE9EB !default;\n$default-border-color:#EBE9EB;\n$header-bg-color: #FCFCFC;\n$gray-text-color-1:#605260;\n$link-color: $primary;\n$link-hover-color: $primary !default;\n$link-hover-decoration: none !default;\n$btn-link-disabled-color: #AFA9AF !default;\n$input-color: $purple;\n$input-focus-color: $purple;\n$input-focus-border-color: transparent !default;\n$input-placeholder-color: #BDB8BD !default;\n$input-bg: #FFF !default;\n$input-focus-bg: #FFF !default;\n$input-border-color: #ECEBEC !default;\n$input-checkbox-disabled: $light-gray !default;\n$input-checkbox-disabled-text: #C5C0C5 !default;\n\n// icons\n$icons-normal-size: 24px !default;\n$icons-small-size: 16px !default;\n$icons-normal-color: #9B939B !default;\n$icons-red-normal-color: $primary !default;\n$icons-hover-color: $dark !default;\n$icons-red-hover-color: $dark !default;\n$icons-disabled-color: #E2DFE2 !default;\n$icon-remove-color: #5e0066;\n$login-info-img-thumbnail-height: 1.846rem !default;\n\n// loading\n$loading-color: #5B0064;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
